import(/* webpackMode: "eager", webpackExports: ["KnowledgeHubArticleView"] */ "/vercel/path0/frontend_next/src/components/views/KnowledgeHubArticleView.tsx");
